import React, { forwardRef } from 'react'

import { Text, TextProps } from '../Text'
import { useFormControl } from '../../hooks/useFormControl'

export interface FormHelperTextProps extends TextProps {
  children?: string | React.ReactNode
}

export const FormHelperText = forwardRef(({ children, ...restProps }: FormHelperTextProps, ref) => {
  const formControl = useFormControl(restProps)

  const _children =
    typeof children === 'string'
      ? children.split('<br />').map(line => (
          <>
            {line}
            <br />
          </>
        ))
      : children

  return (
    <Text
      mt={2}
      ref={ref}
      id={formControl.id ? `${formControl.id}-help-text` : null}
      color="gray.500"
      lineHeight="normal"
      fontSize="sm"
      {...restProps}
    >
      {_children}
    </Text>
  )
})

FormHelperText.displayName = 'FormHelperText'

export default FormHelperText
